import { mount } from "svelte";
import UI from "./UI.svelte";

const app = mount(UI, {
  target: document.getElementById("ui"),
});

export default app;
